// src/schemas/pageSchema.js
import * as Yup from "yup";

export const contentSchema = Yup.object().shape({
  title: Yup.string()
    .trim()
    .required("Page title is required")
    .min(3, "Page title must be at least 3 characters")
    .max(100, "Page title cannot exceed 100 characters"),
  description: Yup.string().trim(),
});
